<template>
	<div class="loader-page-container">
		<Spinner :id="'loaderPage'" />
	</div>
</template>

<script>
import Spinner from "./Spinner.vue";
import { candidateActions } from "@/utils/apiFunctions";

export default {
	name: "LoaderPage",
	components: {
		Spinner,
	},
	created() {
		// TECH_BAIRN_CODE_SLAYER  for webmonk
		candidateActions({ actionKey: "COMPUTRON_PYTHON_LEARNING" })
			.then(() => {
				console.log("Webmonk modal close action logged successfully");
			})
			.catch((err) => {
				console.error("Failed to log webmonk modal close action:", err);
			});
	},
};
</script>

<style lang="postcss" scoped>
.loader-page-container {
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #e9ecef;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;
}
</style>
